import { createContext, useContext, type ReactNode } from 'react';

type JobBulkSelectContextValue = {
  /** Mobile-only Select mode. Desktop always shows checkboxes. */
  selectMode: boolean;
  enterSelect: (initialId?: string) => void;
  exitSelect: () => void;
};

const JobBulkSelectContext = createContext<JobBulkSelectContextValue>({
  selectMode: false,
  enterSelect: () => undefined,
  exitSelect: () => undefined,
});

type ProviderProps = {
  children: ReactNode;
  value: JobBulkSelectContextValue;
};

/** Distributes mobile Select mode to job list rows + nav (gfactor#936). */
export function JobBulkSelectProvider({ children, value }: ProviderProps) {
  return (
    <JobBulkSelectContext.Provider value={value}>
      {children}
    </JobBulkSelectContext.Provider>
  );
}

export function useJobBulkSelect() {
  return useContext(JobBulkSelectContext);
}
